import * as React from "react";
const SvgFiRrInsert = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-insert_svg__a)">
      <path
        fill="#062147"
        d="M6.3 13.214a1 1 0 1 1 1.399-1.429l3.3 3.234V1a1 1 0 0 1 2 0v14.009l3.3-3.223a.999.999 0 1 1 1.399 1.429l-4.293 4.207a1.98 1.98 0 0 1-1.404.579h-.004a2 2 0 0 1-1.412-.586zM23 16h-1.5a2.503 2.503 0 0 0-2.5 2.5v1c0 1.378-1.122 2.5-2.5 2.5h-9A2.503 2.503 0 0 1 5 19.5v-1C5 17.122 3.878 16 2.5 16H1a1 1 0 0 0 0 2h1.5a.5.5 0 0 1 .5.5v1C3 21.981 5.019 24 7.5 24h9c2.481 0 4.5-2.019 4.5-4.5v-1a.5.5 0 0 1 .5-.5H23a1 1 0 0 0 0-2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-insert_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrInsert;
